<template>

    <div v-if="isLoading" class="loading-overlay">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
        </div>
    </div>


    <div class="row">

        <div class="col-xl-12 d-flex">
            <div class="card flex-fill">
                <div class="card-header">
                    <h5 class="card-title">Galeria de Producto</h5>
                </div>
                <div class="card-body card-buttons">
                    <form class="needs-validation" novalidate>

                        <div class="row">
                            <div class="col-12 mt-2 input-block">
                                <label for="name">Nombre</label>
                                <b-form-input type="text" v-model="product.titulo" disabled id="name"
                                    class="form-control" />
                            </div>

                            <div class="col-6 mt-2 input-block">
                                <label>Categoria</label>
                                <select v-model="product.categoriaId" disabled class="form-control">
                                    <option value="" disabled>Selecciona una categoría</option>
                                    <option v-for="category in categories" :key="category.id" :value="category.id">
                                        {{ category.nombre }}
                                    </option>
                                </select>
                            </div>

                            <div class="col-6 mt-2 input-block">
                                <label>Sub Categoria</label>
                                <select v-model="product.subCategoriaId" disabled class="form-control">
                                    <option value="" disabled>Selecciona una Sub Categoría</option>
                                    <option v-for="subCategory in subCategories" :key="subCategory.id"
                                        :value="subCategory.id">
                                        {{ subCategory.nombre }}
                                    </option>
                                </select>
                            </div>

                            <div class="col-12 mt-2 input-block">
                                <label>Imagen</label>
                                <input class="form-control" type="file" @change="handleImageUpload" accept="image/*" />
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-12">
                <div class="card">
                    <div class="card-body card-buttons">
                        <div class="row">
                            <div class="col-xl-12">
                                <h4 class="header-title">Galeria Imagen Producto</h4>

                                <div class="row gallery-container">
                                    <div v-for="galery in galeries" :key="galery.id" class="gallery-item col-2">
                                        <div class="position-relative">
                                            <img class="img-fluid rounded gallery-image"
                                                :src="baseURL + '/producto/obtener_galeria_producto/' + galery.image" />
                                            <span class="badge estado-badge"
                                                :class="galery.estado === 'Agotado' ? 'bg-danger' : 'bg-success'">
                                                {{ galery.estado }}
                                            </span>
                                        </div>
                                        <div class="text-center mt-1" v-if="galery.etiquetas && galery.etiquetas.length">
                                            <span class="badge bg-info etiqueta-badge">
                                                <i class="fas fa-tags"></i> {{ galery.etiquetas.length }} variedad(es)
                                            </span>
                                        </div>
                                        <div class="text-center mt-2 btn-group btn-group-sm w-100" role="group">
                                            <button type="button" @click="toggleEstado(galery)"
                                                class="btn"
                                                :class="galery.estado === 'Agotado' ? 'btn-outline-success' : 'btn-outline-warning'"
                                                :title="galery.estado === 'Agotado' ? 'Marcar Activo' : 'Marcar Agotado'">
                                                <i class="fas fa-sync-alt"></i>
                                            </button>
                                            <button type="button" @click="openEtiquetaModal(galery)"
                                                class="btn btn-outline-info" title="Etiquetar variedades">
                                                <i class="fas fa-tags"></i>
                                            </button>
                                            <button type="button" @click="deleteImg(galery)"
                                                class="btn btn-outline-danger" title="Eliminar">
                                                <i class="fas fa-trash-alt"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- end col -->
                        </div>
                        <!-- end row -->
                    </div>
                </div>
                <!-- end card -->
            </div>
        </div>

    </div>

    <!-- Modal Etiquetar Variedades -->
    <div class="modal fade" id="etiquetaModal" tabindex="-1" ref="etiquetaModal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header bg-info bg-opacity-10">
                    <h5 class="modal-title">
                        <i class="fas fa-tags me-2"></i>Etiquetar variedades de la foto
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
                </div>
                <div class="modal-body" v-if="selectedGaleria">
                    <div class="d-flex align-items-center mb-3 p-3 bg-light rounded">
                        <img class="img-thumbnail me-3"
                            style="width: 60px; height: 60px; object-fit: cover;"
                            :src="baseURL + '/producto/obtener_galeria_producto/' + selectedGaleria.image" />
                        <div>
                            <small class="text-muted">Selecciona las variedades a las que pertenece esta foto.</small>
                        </div>
                    </div>

                    <div v-if="variedades.length === 0" class="text-muted text-center py-3">
                        Este producto no tiene variedades registradas.
                    </div>
                    <div v-else class="form-check" v-for="variedad in variedades" :key="variedad.id">
                        <input class="form-check-input" type="checkbox" :id="'variedad-' + variedad.id"
                            :value="variedad.id" v-model="selectedVariedadIds" />
                        <label class="form-check-label" :for="'variedad-' + variedad.id">
                            <span v-if="variedad.talla">Talla: {{ variedad.talla }} </span>
                            <span v-if="variedad.color">Color: {{ variedad.color }} </span>
                            <span v-if="variedad.medida">Medida: {{ variedad.medida }} </span>
                            <small class="text-muted">({{ variedad.sku }})</small>
                        </label>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                    <button type="button" class="btn btn-info" :disabled="savingEtiquetas || variedades.length === 0"
                        @click="saveEtiquetas">
                        <span v-if="savingEtiquetas" class="spinner-border spinner-border-sm me-1"></span>
                        Guardar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';


export default {

    data() {
        return {
            isLoading: false,
            product: {
                titulo: '',
                categoriaId: '',
                subCategoriaId: '',
            },
            categories: [],
            subCategories: [],
            subCategoriesAll: [],
            baseURL: api.defaults.baseURL,
            imagePreview: '@/assets/img/category-img-03.jpg',
            selectedImage: null,
            galeries: [],

            variedades: [],
            selectedGaleria: null,
            selectedVariedadIds: [],
            etiquetaModal: null,
            savingEtiquetas: false,

            productId: this.$route.params.id,
        }
    },


    mounted() {
        this.getProductId();
        this.loadCategories();
        this.loadSubCategories();
        this.loadGaleries();
        this.loadVariedades();
    },

    methods: {
        async loadCategories() {
            try {
                const response = await api.get('/categoria');
                this.categories = response.data;
            } catch (err) {
                this.error = 'Error al cargar categorías';
                console.error(err);
            } finally {
                this.isLoading = false;
            }
        },
        async loadSubCategories() {
            try {
                const response = await api.get('/sub_categoria');
                this.subCategories = response.data;
                this.subCategoriesAll = response.data;
            } catch (err) {
                this.error = 'Error al cargar sub-categorías';
                console.error(err);
            } finally {
                this.isLoading = false;
            }
        },
        async loadGaleries() {
            try {
                const response = await api.get(`/producto/obtener_galeria_producto_admin/${this.productId}`);
                this.galeries = response.data.data;
            } catch (err) {
                this.error = 'Error al cargar Galeria';
                console.error(err);
            }
        },
        async loadVariedades() {
            try {
                const response = await api.get(`/variedad/${this.productId}`);
                this.variedades = response.data;
            } catch (err) {
                console.error(err);
            }
        },
        async openEtiquetaModal(galery) {
            this.selectedGaleria = galery;
            this.selectedVariedadIds = [];

            if (!this.etiquetaModal) {
                const bootstrap = await import('bootstrap');
                this.etiquetaModal = new bootstrap.Modal(this.$refs.etiquetaModal);
            }

            try {
                const response = await api.get(`/etiqueta/galeria/${galery.id}`);
                this.selectedVariedadIds = response.data.data.map(e => e.variedadId);
            } catch (error) {
                console.error(error);
                this.$toast.error('Error al cargar las etiquetas de la foto');
            }

            this.etiquetaModal.show();
        },
        async saveEtiquetas() {
            this.savingEtiquetas = true;

            try {
                await api.put(`/etiqueta/galeria/${this.selectedGaleria.id}`, {
                    variedadIds: this.selectedVariedadIds
                });
                this.$toast.success('Etiquetas actualizadas con éxito');
                this.etiquetaModal.hide();
                this.loadGaleries();
            } catch (error) {
                console.error(error);
                this.$toast.error('Error al actualizar las etiquetas');
            } finally {
                this.savingEtiquetas = false;
            }
        },
        async getProductId() {
            try {
                const response = await api.get(`/producto/obtener/${this.productId}`);
                this.product = response.data;
            } catch (err) {
                this.error = 'Error al cargar sub-categorías';
                console.error(err);
            } finally {
                this.isLoading = false;
            }
        },
        async handleImageUpload(event) {
            const file = event.target.files[0];

            if (file) {
                this.selectedImage = file;

                const reader = new FileReader();
                reader.onload = (e) => {
                    this.imagePreview = e.target.result;
                };
                reader.readAsDataURL(file);

                const formData = new FormData();
                formData.append("image", this.selectedImage);
                formData.append("productoId", this.productId)

                try {
                    const response = await api.post("/producto/subir_imagen_producto_admin", formData);
                    this.isLoading = false;
                    //this.$toast.success('Imagen agregada con éxito');
                    this.loadGaleries();
                    this.resetForm();
                } catch (error) {
                    this.isLoading = false;
                    this.$toast.error('Error al agregada Imagen');
                }
            } else {
                this.imagePreview = null;
                this.selectedImage = null;
            }
        },
        async submitForm() {

            this.isLoading = true;

            const formData = new FormData();
            if (this.selectedImage) {
                formData.append("portada", this.selectedImage);
            }

            try {
                const response = await api.post("/producto/registrar", formData);
                this.isLoading = false;
                this.$toast.success('Producto agregada con éxito');
                this.resetForm();
            } catch (error) {
                this.isLoading = false;
                this.$toast.error('Error al agregada el Producto');
            }
        },
        async toggleEstado(galery) {
            const nuevoEstado = galery.estado === 'Agotado' ? 'Activo' : 'Agotado';
            this.isLoading = true;

            try {
                await api.put(`/producto/actualizar_estado_galeria_producto_admin/${galery.id}`, { estado: nuevoEstado });
                galery.estado = nuevoEstado;
                this.$toast.success(`Imagen marcada como ${nuevoEstado}`);
            } catch (error) {
                this.$toast.error('Error al actualizar el estado');
                console.error('Error:', error);
            } finally {
                this.isLoading = false;
            }
        },
        async deleteImg(galery) {
            console.log(galery);
            const result = await this.$swal.fire({
                title: '¿Eliminar Foto?',
                text: 'Esta acción no se puede deshacer.',
                icon: 'error',
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            });

            if (!result.isConfirmed) return;
            this.isLoading = true;

            try {
                const response = await api.delete(`/producto/eliminar_galeria_producto_admin/${galery.id}`);
                this.isLoading = false;
                this.$toast.success('La foto eliminada con éxito');
                this.loadGaleries();
            } catch (error) {
                this.isLoading = false;
                this.$toast.error('Error al eliminar Foto');
                console.error("Error:", error);
            }
        },
        resetForm() {
            this.imagePreview = null;
            this.selectedImage = null;
        }
    },

};
</script>

<style>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css');
td {
    cursor: pointer;
    transition: background-color 0.2s;
}

.is-invalid {
    border-color: #dc3545;
}

thead tr th {
    background-color: #7539FF !important;
    color: white !important;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    width: 100vw;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(2px);
}

.small-lg {
    font-size: 0.9rem !important;
}

.actions {
    white-space: nowrap;
}

.actions .btn {
    padding: 0.35rem 0.5rem;
    font-size: 0.875rem;
}

.gallery-container {
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    /* Espacio entre imágenes */
    width: 100%;
}

.gallery-item {
    flex: 1 1 calc(20% - 15px);
    /* 3 imágenes por fila con espacio */
    min-width: 150px;
    /* Ancho mínimo para cada imagen */
    max-width: 100%;
    box-sizing: border-box;
}

.gallery-image {
    width: 100%;
    height: 150px;
    /* Altura fija para todas las imágenes */
    object-fit: cover;
    /* Para que la imagen cubra el espacio manteniendo proporciones */
    border: 1px solid #ddd;
    /* Borde opcional */
}

.estado-badge {
    position: absolute;
    top: 6px;
    right: 6px;
    font-size: 11px;
    padding: 4px 8px;
}

.estado-btn {
    color: white;
    border: none;
    padding: 5px 12px;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 5px;
}

.btn-marcar-agotado {
    background-color: #ff9800;
}

.btn-marcar-agotado:hover {
    background-color: #e68900;
}

.btn-marcar-activo {
    background-color: #28a745;
}

.btn-marcar-activo:hover {
    background-color: #218838;
}

.delete-btn {
    background-color: #ff4444;
    color: white;
    border: none;
    padding: 5px 12px;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
    display: inline-flex;
    align-items: center;
    gap: 5px;
}

.delete-btn:hover {
    background-color: #cc0000;
    transform: translateY(-1px);
    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
}

.delete-btn:active {
    transform: translateY(0);
}



@media (max-width: 768px) {
    .gallery-item {
        flex: 1 1 calc(50% - 15px);
        /* 2 imágenes por fila en móviles */
    }
}

@media (max-width: 480px) {
    .gallery-item {
        flex: 1 1 100%;
        /* 1 imagen por fila en móviles muy pequeños */
    }
}
</style>
